import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import React from "react";

interface SyncFrequencySelectProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  sx?: any;
}

const SYNC_FREQUENCY_OPTIONS = [
  {
    value: "manual",
    label: "Manual Only",
    description: "Sync only when manually triggered",
  },
  { value: "daily", label: "Daily", description: "Sync once per day" },
  { value: "weekly", label: "Weekly", description: "Sync once per week" },
  { value: "monthly", label: "Monthly", description: "Sync once per month" },
];

export default function SyncFrequencySelect({
  value,
  onChange,
  disabled = false,
  sx,
}: SyncFrequencySelectProps) {
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value);
  };

  const selectedOption = SYNC_FREQUENCY_OPTIONS.find(
    (option) => option.value === value
  );

  return (
    <FormControl fullWidth disabled={disabled} sx={sx}>
      <InputLabel>Auto-Sync Frequency</InputLabel>
      <Select value={value} label="Auto-Sync Frequency" onChange={handleChange}>
        {SYNC_FREQUENCY_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <div>
              <Typography variant="body2" sx={{ fontWeight: "medium" }}>
                {option.label}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {option.description}
              </Typography>
            </div>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export { SYNC_FREQUENCY_OPTIONS };
